import React, { useEffect } from 'react'
import { COLORES } from '../../../config/colores'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_BODEGAS_BUQUES } from '../../../config/forms'
import { Button } from '@material-ui/core'
import BodegasBuqueView from './BodegasBuqueView'
import CamposBodegaBuque from './CamposBodegaBuque'
import { updateTablaBodegasBuque, submitBodegaBuque } from '../actions/PlanDeEmbarqueActions'

function BodegasBuque (props) {
  const { buque, updateTablaBodegasBuque } = props

  useEffect(() => {
    updateTablaBodegasBuque(buque)
  }, [updateTablaBodegasBuque, buque])

  const handleSubmit = () => {
    const { numeroBodega, bodegas, change: formChange } = props
    if (!isNaN(numeroBodega)) {
      const contiene = bodegas.find((b) => b.nombre.trim() === `BODEGA${numeroBodega}`)
      if (!contiene) {
        props.submitBodegaBuque(buque, numeroBodega)
      } else {
        toast.error(`Ya se encuenta cargada la BODEGA${numeroBodega}`)
      }
    } else {
      toast.error('Debe ingresar un número para agregar una bodega.')
    }
    formChange('numeroBodega', '')
  }

  return (
    <>
      <CamposBodegaBuque style={{ margin: '22px 0' }} />
      <Button
        variant='contained'
        style={{ color: COLORES.blue.primary, width: '100%', fontWeight: 'bold' }}
        size='small'
        onClick={handleSubmit}
      >
                Agregar bodega
      </Button>

      <div style={{ marginTop: '22px' }}>
        <BodegasBuqueView />
      </div>

    </>
  )
}

const selector = formValueSelector(FORM_BODEGAS_BUQUES)

const mapStateToProps = (state) => ({
  numeroBodega: selector(state, 'numeroBodega'),
  bodegas: state.buque.bodegas
})

const mapActionsToProps = {
  updateTablaBodegasBuque,
  submitBodegaBuque
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_BODEGAS_BUQUES
})

export default withRedux(withReduxForm(BodegasBuque))
